export default __webpack_public_path__ + "static/media/paid-icon.cef891ee.svg";